<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 sm12 md12 lg12 xl6>
            <v-card>
              <v-card-title class="pb-5">
                <!--                                    v-if="$can('transaction_create')"-->
                <v-btn to="/panels" rounded color="#A5668B" class="text-white">
                  <v-icon>mdi-backspace-reverse-outline</v-icon>
                  بازگشت
                </v-btn>
                <v-spacer/>
                {{ $route.meta.title }}
                <v-spacer/>
                <v-btn @click="addPack" color="#50858B" rounded class="text-white">
                  <v-icon>mdi-refresh</v-icon>
                  ذخیره
                </v-btn>
                <!--                            <v-card elevation="2" outlined>-->
              </v-card-title>


              <v-card-text>
                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                        :rules="rules.title"
                        v-model="title"
                        :error-messages="errors.title"
                        label="عنوان"
                        required
                        outlined
                        dense
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <price-input :dense="true" :label="'قیمت'" v-model="price"></price-input>
                  </v-flex>
                </v-row>
                <v-row>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                        :rules="rules.expire"
                        v-model="expire"
                        :error-messages="errors.expire"
                        type="number"
                        label="تاریخ انقضا(روز)"
                        outlined
                        dense
                    >

                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-select
                        v-model="service"
                        :rules="rules.service"
                        :items="services"
                        item-text="nameLand"
                        item-value="id"
                        label="انتخاب سرویس"
                        :error-messages="errors.service_id"
                        outlined
                        multiple
                        dense
                        return-object
                    ></v-select>
                  </v-flex>
                </v-row>


                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-select
                        v-model="owner"
                        :rules="rules.owner"
                        :items="owners"
                        item-text="name"
                        :error-messages="errors.own_number"
                        item-value="id"
                        label="مالک"
                        outlined
                        dense
                        return-object
                    ></v-select>

                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-select
                        v-model="show"
                        :items="shows"
                        item-text="name"
                        item-value="id"
                        :error-messages="errors.show"
                        label="وضعیت"
                        outlined
                        dense
                        return-object
                    ></v-select>

                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                        v-model="sortOrder"
                        :rules="rules.sortOrder"
                        label="ترتیب نمایش"
                        :error-messages="errors.sort_order"
                        outlined
                        dense
                    >
                    </v-text-field>

                  </v-flex>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-select
                        v-model="roleid"
                        :rules="rules.status"
                        :items="roles"
                        item-text="name_fa"
                        item-value="id"
                        :error-messages="errors.role_id"
                        label="انتخاب نقش"
                        outlined
                        dense
                        return-object></v-select>
                  </v-flex>
                </v-row>

                <!--                تعرفه های پیامک لند-->
                <v-row>
                  <v-flex
                      xs12 sm12 md6 lg6 xl6
                      class="p-2">

                    <sub-line-picker v-model="subline"></sub-line-picker>
                    <!--                                  <v-btn-->
                    <!--                                      block-->
                    <!--                                      dark-->
                    <!--                                      @click="addCount">ا نتخاب تعرفه خطوط-->
                    <!--                                  </v-btn>-->
                  </v-flex>


                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">

                    <smsTariffPicker v-model="tariff"></smsTariffPicker>

                  </v-flex>


                </v-row>

                <!--                تعرفه های ربات لند-->


                <v-row>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                        v-model="rb.rb.number"
                        :error-messages="errors.number"
                        type="number"
                        label="شماره"
                        outlined
                        dense
                    >

                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                        v-model="rb.rb.chat"
                        :error-messages="errors.chat"
                        type="number"
                        label="تعرفه چت"
                        outlined
                        dense
                    />

                  </v-flex>
                </v-row>

                <v-row>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                        v-model="rb.rb.new"
                        :error-messages="errors.new"
                        type="number"
                        label="شماره جدید"
                        outlined
                        dense
                    >

                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                        v-model="rb.rb.unique"
                        :error-messages="errors.unique"
                        type="number"
                        label="شماره یکتا"
                        outlined
                        dense
                    />

                  </v-flex>
                </v-row>






                <v-row v-for="(item, i) in features" :key="i">

                  <v-flex xs6 sm6 md6 lg6 xl6 class="p-2">
                    <v-text-field
                        v-model="item.key"
                        label="نوع ویژگی"
                        outlined
                        dense>

                    </v-text-field>
                  </v-flex>

                  <v-flex xs6 sm6 md6 lg6 xl6 class="p-2">
                    <v-text-field
                        v-model="item.value"
                        label="مقدار ویژگی"
                        outlined
                        dense>

                    </v-text-field>
                  </v-flex>

                </v-row>
                <v-row>
                  <v-flex
                      :class="features.length>0 ?'xs12 sm12 md6 lg6 xl6' : 'xs12 sm12 md12 lg12 xl12'"
                      class="p-2">

                    <v-btn
                        color="info"
                        block
                        dark
                        @click="addCount"> افزودن تعداد ویژگی
                    </v-btn>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-btn
                        color="red"
                        block
                        dark
                        :disabled="features.length == 0"
                        @click="decreaseCount">کاهش تعداد ویژگی
                    </v-btn>
                  </v-flex>

                </v-row>
                <v-row>
                  <v-flex class="p-2">
                    <v-textarea
                        v-model="description"
                        :rules="rules.description"
                        label="توضیحات"
                        :error-messages="errors.description"
                        outlined
                        dense>

                    </v-textarea>
                  </v-flex>
                </v-row>

              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {SET_BREADCRUMB} from "../../../../core/services/store/breadcrumbs.module";
import smsTariffPicker from "@/view/pages/pickers/smsTariffPicker";
import priceInput from "@/view/pages/pickers/priceInput";
import subLinePicker from "@/view/pages/pickers/subLinePicker";
import permissionPicker from "@/view/pages/pickers/permissionPicker";


export default {
  components: {smsTariffPicker, priceInput, subLinePicker, permissionPicker},
  data() {
    return {
      service: [],
      services: [],
      title: null,
      price: 0,
      expire: null,
      permissions: {},
      roleid: null,
      tariff: {},
      rb:{
        rb:{
          number: null,
          chat: null,
          new: null,
          unique: null
        }
      },
      subline: {},
      tariffs: [],
      owner: {id: null},
      owners: [
        {id: 1, name: 'فعال'},
        {id: 0, name: 'غیر فعال'}
      ],
      show: {id: null},
      shows: [
        {id: 1, name: 'فعال'},
        {id: 0, name: 'غیر فعال'}
      ],
      sortOrder: null,
      features: [],
      description: null,
      roles: [],
      errors: [],
      rules: {
        title: [val => (val || '').length > 0 || 'فیلد عنوان الزامی می باشد.'],
        services: [(val) => val.length > 0 || 'فیلد سرویس الزامی می باشد.'],
        price: [val => (val || '').length > 0 || 'فیلد قیمت الزامی می باشد.'],
        expire: [val => (val || '').length > 0 || 'فیلد تاریخ انقضا الزامی می باشد.'],
        // permissions: [val => (val || []).length > 0 || 'فیلد دسترسی الزامی می باشد.'],
        // tariff: [val => !!val || 'فیلد تعرفه الزامی می باشد.'],
      },

    }
  },
  mounted() {
    this.services = this.getService().data;
    this.fetchIndexData();
    this.getTariff();
    this.getRoles();
  },
  created() {
    this.$store.dispatch(SET_BREADCRUMB, [{title: this.$route.meta.title}]);

  },


  methods: {
    ...mapActions('PermissionsIndex', [
      'fetchIndexData',
      'setQuery',
      'resetState'
    ]),

    addPack() {

      // let checkedPermission=[]
      // for (let a in this.permissions){
      //   checkedPermission.push(a)
      // }


      let role_data = this.roleid.id


      console.log(this.rb.rb)

      this.requestApiPost('pack', {
        title: this.title,
        price: this.price.replace(/,/g, ''),
        expire: this.expire,
        // permissions_id: checkedPermission,
        // permissionStatus: this.permissions,
        tariff_id: this.tariff,
        rb:this.rb.rb,
        own_number: this.owner.id,
        show: this.show.id,
        sort_order: this.sortOrder,
        pack_id: this.subline,
        features: this.features,
        description: this.description,
        service_id: this.service.map(item => item.id),
        role_id: role_data,
      }).then(response => {
        this.$toast.success('بسته جدید با موفقیت ایجاد شد.');
        this.$router.push({name: 'panels.index'});
      }).catch(({response}) => {
        this.errors = response;
      });

    },
    addCount() {
      this.features.push({
        id: this.features.length + 1,
        key: null,
        value: null,
      })
    },
    decreaseCount() {
      if (this.features.length > 0) {
        this.features.pop()
      }
    },

    getTariff() {
      this.requestApiGet('tariff',
      ).then(({data}) => {
        this.tariffs = data.data;
      })
    },

    getRoles() {
      this.requestApiGet('admin/roles',
      ).then(response => {
        this.roles = response.data.data;
      })
    },
  },

  computed: {
    ...mapGetters(["layoutConfig"]),
    ...mapGetters('PermissionsIndex', ['data', 'total', 'loading']),

    config() {
      return this.layoutConfig();
    }
  },
  watch: {
    query: {
      handler(query) {
        this.setQuery(query)
        this.fetchIndexData()
      },
      deep: true
    }
  },

}
</script>
